const actionType = {
    UPDATE_HIREABLITY_STATUS: "UPDATE_HIREABLITY_STATUS",
    SET_TOTAL_MODULE_SCORES: "SET_TOTAL_MODULE_SCORES",
    UPDATE_TOTAL_MODULE_SCORES: "UPDATE_TOTAL_MODULE_SCORES",
    UPDATE_MANUAL_VADC_SCALE_NARRATIVES: "UPDATE_MANUAL_VADC_SCALE_NARRATIVES",
    TOASTENABLE: "TOASTENABLE",
    SET_CHAPTER_PARAMS: "SET_CHAPTER_PARAMS",
    SELECT_COMPETENCY: "SELECT_COMPETENCY"
}
export default actionType
